import React from "react";

import { InputBase, Box, createStyles, Typography } from "@mui/material";
import styles from "./CustomInput.module.css";

const CustomInput = ({errorMsg, ...moreProps}) => {
  return (
    <>
    <Box
      // className={styles.container}
      sx={{
        backgroundColor: "background.paper",
        borderRadius: "10px",
      }}
    >
      <InputBase placeholder="test" className={styles.input} {...moreProps} />
      
    </Box>
    {errorMsg && <Box ml={1} className="anim--height-slide-down">
      <Typography align="left" color="red">{errorMsg}</Typography></Box>}
    </>
  );
};

export default CustomInput;
